import { Box } from '@mantine/core';
import { getHotkeyHandler } from '@mantine/hooks';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { RichEditor } from '../../../components/RichEditor';
import { FORM_SHORTCUTS } from '../../../constants/shortcuts';
import { useFeatureFlags } from '../../../utils/featureFlags';

export const QuestionReplyInput = observer(
	({
		onSubmit,
		onChange,
		className,
		...props
	}: {
		onSubmit?: () => void;
		onChange?: (value: string | undefined) => void;
		className?: string;
	} & Omit<React.ComponentProps<typeof RichEditor>, 'onChangeCallback'>) => {
		const { askAiInQuestion } = useFeatureFlags();

		const handleKeyboardSubmit = useCallback(
			(event: React.KeyboardEvent<HTMLElement> | KeyboardEvent) => {
				event.preventDefault();
				onSubmit?.();
			},
			[onSubmit]
		);

		return (
			<Box
				className={`${className} focus-input`}
				onKeyDown={getHotkeyHandler([
					[FORM_SHORTCUTS.SUBMIT_WITH_MOD[0], handleKeyboardSubmit],
				])}
			>
				<RichEditor
					{...props}
					onChangeCallback={onChange}
					disableTopGap
					canMentionSecodaAi={askAiInQuestion}
					disableChangeCallbackDebounce
				/>
			</Box>
		);
	}
);
